import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { loginUser, connectWithFacebook } from "./authServices";
import { Link, useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import { FaFacebook } from "react-icons/fa";

import { FaEyeSlash } from "react-icons/fa";

import login from "../../Assets/login.svg";
import logo from "../../Assets/logo.svg";
import { db } from "../../Firebase";
import { doc, onSnapshot } from "firebase/firestore";
import "./auth.css";
import {
  DASHBOARD_ADMIN_NAVIGATION,
  DASHBOARD_PROF_NAVIGATION,
  DASHBOARD_ETUDIANT_NAVIGATION,
  PASSWORD_OUBLIER_NAVIGATION,
  INSCRIPTION_NAVIGATION,
} from "../../Routes/NAVIGATION_PATH";
import { AiFillEye } from "react-icons/ai";
import { IoMdLogIn } from "react-icons/io";

export default function Inscription() {
  const [passwordShown, setPasswordShown] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const navigate = useNavigate();
  const { register, handleSubmit, reset } = useForm();

  const handleRedirect = (type) => {
    if (type === "admin") {
      navigate(DASHBOARD_ADMIN_NAVIGATION);
    } else if (type === "prof") {
      navigate(DASHBOARD_PROF_NAVIGATION);
    } else if (type === "etudiant") {
      navigate(DASHBOARD_ETUDIANT_NAVIGATION);
    }
  };

  const connectSuccess = (userCredential) => {
    const user_id = userCredential.user.uid;
    sessionStorage.setItem("user_id", user_id);
    onSnapshot(doc(db, "users", user_id), (doc) => {
      const user = doc.data();
      const userWithId = { ...user, id: user_id };
      sessionStorage.setItem("user", JSON.stringify(userWithId));
      handleRedirect(user.user_type);
    });
    toast.success("Connexion reussie !");
  };

  const handleConnectWithFacebook = () => {
    connectWithFacebook().then(connectSuccess);
  };

  const onSubmit = (data) => {
    const { email, password } = data;
    loginUser(email, password)
      .then(connectSuccess)
      .catch((error) => {
        const errorCode = error.code;
        if(errorCode === "auth/network-request-failed"){
          toast.error("Impossible de se connecter, votre connexion est faible !");
        }else{
          toast.error("Utilisateur introuvable ou mot de passe incorect!");
        }
        console.log(errorCode);
      });
  };

  return (
    <div className="container-fluid position-fixed top-0 p-0" id="login">
      <div className="row p-0 d-flex justify-content-center align-items-center w-100 vh-100">
        <div className="col-lg-6  p-0 pt-0 d-none d-lg-block lo">
          <div className="container-bg style-border  d-flex justify-content-center align-items-center w-100 vh-100 ">
            <img src={login} className="img-fluid vh-100 imLogin" />
          </div>
        </div>

        <div className="col-lg-6 min-vh-100">
          <div className="">
            <div className="container-img w-100 d-flex justify-content-center text-center">
              <img src={logo} className="img-fluid logLogin " />
            </div>
            <div className="tiitle-h2">
              <h2>CONNEXION</h2>
            </div>
            <Form onSubmit={handleSubmit(onSubmit)} className="mx-auto">
              <Form.Group className="" controlId="formBasicEmail">
                <Form.Label>Adresse email ou nom utilisateur</Form.Label>
                <Form.Control
                  {...register("email")}
                  type="email"
                  placeholder="Enter email"
                />
              </Form.Group>

              <Form.Group
                className="mb-3 pt-3 position-relative"
                controlId="formBasicPassword"
              >
                <Form.Label>Mot de passe</Form.Label>
                <Form.Control
                  {...register("password")}
                  type={passwordShown ? "text" : "password"}
                  placeholder="Password"
                />
                {
                  passwordShown === false ?
                  < AiFillEye
                    className="position-absolute eye"
                    onClick={togglePasswordVisiblity}
                    size={20}
                  />
                  :
                  <FaEyeSlash
                  className="position-absolute eye"
                  onClick={togglePasswordVisiblity}
                  size={20}
                  />
                }


              </Form.Group>
              <div className="text-center">
                <button type="submit" className="block-btn btn btn-md me-2">
                  <span> Connexion</span> <IoMdLogIn />
                </button>
                <button
                  onClick={handleConnectWithFacebook}
                  className="block-btn1 btn btn-md ms-2"
                  type="button"
                >
                  <FaFacebook />
                  <span> Facebook</span>
                </button>
              </div>
              <div className="mb-3 form-check">
                <Link to={INSCRIPTION_NAVIGATION}></Link>
                <div className="d-flex pt-3 pwd justify-content-center">
                  <Link to={PASSWORD_OUBLIER_NAVIGATION}>
                    <span>Vous avez oublié votre mot de passe ?</span>
                  </Link>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
